module.exports = __webpack_public_path__ + "static/media/person.cccc5bb8.svg";